// this type is autogenerated via `bin/rails app_config:generate`
// do not manually edit this file

export type AppConfigType = {
  app_name: string
  direct_uploads_url: string
}

const metaTags = document.querySelectorAll<HTMLMetaElement>("meta[data-config]")
const config = {} as AppConfigType

metaTags.forEach((meta) => {
  const name = meta.getAttribute("name")
  const content = meta.getAttribute("content")
  if (name && content !== null) {
    config[name as keyof AppConfigType] = content
  }
})

export const AppConfig = config
